<template>
    <v-row no-gutters>
        <v-col cols="12">
            <v-card class="pa-5 my-5">
                <v-row no-gutters>
                    <v-col class="pa-4">
                        <div>
                            <div class="headline mb-4">
                                {{ $t("Get set up to work with team") }}
                            </div>
                            <div>
                                {{
                                    $t(
                                        "Company account allows you to use tools for teams, get deeper insights etc. Raise the quality of your team's workflow and lead a more profitable business."
                                    )
                                }}
                            </div>
                        </div>
                        <v-row>
                            <v-btn color="primary" class="mt-5" text @click="onCreateCompanyClick">
                                <v-icon left>mdi-plus-box</v-icon>
                                {{ $t("Create company account") }}
                            </v-btn>
                        </v-row>
                    </v-col>
                    <v-col class="shrink px-4 pb-4">
                        <img height="170px" width="auto" :src="base_url + '/static/img/career_1.svg'" />
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
        <v-col cols="12">
            <v-row no-gutters justify="center">
                <span class="text-center body-2 grey--text">
                    {{ $t("By creating a company account you activate Uku free subscription for {0} days.").format(freeTrialDays) }}
                    <a @click="onReadMoreClick">{{ $t("Read more ›") }}</a>
                </span>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import router from "../../router";
import AccountModule from "../../store/modules/account";
import AppModule from "../../store/modules/app";
export default {
    name: "CreateCompanyBlock",
    setup() {
        const { freeTrialDays } = AppModule();
        const { current_account } = AccountModule();
        const protocol = process.env.VUE_APP_PROTOCOL ? process.env.VUE_APP_PROTOCOL : "";
        const host = process.env.VUE_APP_HOST ? process.env.VUE_APP_HOST : "";
        const base_url = `${protocol}://${host}`;
        const onReadMoreClick = () => {
            if (current_account.value && current_account.value.region_code === "ee") {
                window.open("https://getuku.ee/hinnad", "_blank");
            } else {
                window.open("https://getuku.com/pricing", "_blank");
            }
        };
        const onCreateCompanyClick = () => {
            router.push({ name: "create_company" });
        };
        return {
            base_url,
            onReadMoreClick,
            onCreateCompanyClick,
            freeTrialDays
        };
    }
};
</script>
